import _regeneratorRuntime from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import withTimeout from '../../utils/timeout-promise';
import getOAuthServerMetadata from '../../config/getOAuthServerMetadata';
import buildAuthorizationUrl from '../../utils/buildAuthorizationUrl';
import generateRandomString from '../../utils/generateRandomString';
var AUTH_CODE_IFRAME_TIMEOUT_MS = 5000;

var getAuthCodeViaIframe = function getAuthCodeViaIframe(authorizeRequest, authServerConfig) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var iframeId, iframe, authCodeUrl, _getOAuthServerMetada, issuer, authCodeRequest;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            iframeId = generateRandomString(32);
            iframe = document.getElementById(iframeId);

            if (!iframe) {
              iframe = document.createElement('iframe');
              iframe.setAttribute('id', iframeId);
              iframe.setAttribute('width', '0');
              iframe.setAttribute('height', '0');
              document.body.appendChild(iframe);
            }

            authCodeUrl = buildAuthorizationUrl(authorizeRequest, authServerConfig);
            iframe.setAttribute('src', authCodeUrl);
            _getOAuthServerMetada = getOAuthServerMetadata(authServerConfig), issuer = _getOAuthServerMetada.issuer;
            authCodeRequest = new Promise(function (resolve, reject) {
              function messageListener(evt) {
                if (evt.origin !== issuer) return;
                if (!evt.data.type) return;

                if (evt.data.type === 'authorization_response') {
                  var source = evt.source;

                  if (source === null) {
                    return;
                  }

                  if (evt.source !== iframe.contentWindow) {
                    return;
                  }

                  var response = evt.data.response;

                  if (authorizeRequest.state !== response.state) {
                    var error = {
                      error: 'unknown_error',
                      error_description: "State doesn't match. Malicious request"
                    };
                    reject(error);
                  } else resolve(response);
                }

                window.removeEventListener('message', messageListener);
              }

              window.addEventListener('message', messageListener, false);
            });
            return _context.abrupt("return", withTimeout(authCodeRequest, AUTH_CODE_IFRAME_TIMEOUT_MS, function () {
              var error = {
                error: 'timeout',
                error_description: "Timeout when waiting for auth code from iframe: ".concat(authCodeUrl)
              };
              return error;
            }).finally(function () {
              if (iframe) {
                document.body.removeChild(iframe);
              }
            }));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

export default getAuthCodeViaIframe;